import * as React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Post } from '../../types';
import moment from 'moment-timezone'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';



export default function PostParts(props: {
  post: Post
  style?: {}
}) {

  const { post } = props


  return (
    <React.Fragment>
      <CardActionArea component="a" target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_GOTO_ARTICLE_URL}archives/${post.id}`}
        style={props.style}
      >
        <Card
          sx={{ mb: 3 }}
        >
          <CardContent >
            <CardMedia
              component="img"
              width="100%"
              height="100%"
              image={typeof post.post_image === "string" ? post.post_image : post.post_image?.url}
            />
            {post.show_category_name &&
              <div style={{
                position: 'absolute',
                color: 'white',
                fontWeight: "bold",
                paddingLeft: "2px",
                paddingRight: "2px",
                background: "rgba(3,166,25,1)",
                top: 20,
                left: '5%',
              }}>
                {post.show_category_name}
              </div>}
            <Typography component="h2" variant="h5" sx={{ mb: 1 }}>
              {post.post_title}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary">
              <Grid style={{ display: "flex", flexDirection: "row-reverse" }}>
                {moment(post.post_date).utc().format("YYYY/MM/DD HH:mm:ss")}
                <AccessAlarmIcon />
              </Grid>
              <Grid style={{ display: "flex" }}>
                {post.dlsite_rate && (
                  <Paper elevation={1} sx={{ p: 0.5, mr: 3 }}
                    style={{
                      background: "#4BAEF3",
                      color: "#fafafa"
                    }}
                  >
                    {`dlsite${post.dlsite_rate}%割引`}
                  </Paper>
                )}
                {post.dmm_rate && (
                  <Paper elevation={1} sx={{ p: 0.5, }}
                    style={{
                      background: "#D75050",
                      color: "#fafafa"
                    }}
                  >
                    {`dmm${post.dmm_rate}%割引`}
                  </Paper>
                )}
              </Grid>
            </Typography>
          </CardContent>
        </Card>
      </CardActionArea>
    </React.Fragment >
  );
}